import { appConstants } from '../../../constants'

const initialState = {
  dataLatest: [],
  loading: false,
  error: null
}

export const reducerLatest = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.GET_LATEST_SUCCESS :
      return {
        ...state,
        loading: false,
        error: null,
        dataLatest: [...action.payload.latest]
      }
    case appConstants.GET_LATEST_REQUEST :
      return {
        ...state,
        loading: true
      }
    case appConstants.GET_LATEST_ERROR :
      return {
        ...state,
        error: { ...action.payload.message }
      }
    default:
      return state
  }
}
